import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface Params {
  clientId: string;
  accountId: string;
  snapIds: string[];
}

const sendAppealRequest = ({ clientId, accountId, snapIds }: Params) =>
  authFetch('/Adviser/ManagedAccountInvestigation/Appeal', {
    method: 'POST',
    ...httpBodyOptions(
      {
        clientId,
        managedAccountId: accountId,
        snapIds,
      },
      true,
    ),
  });

export const useSendAppealRequestMutation = () => {
  return useMutation(sendAppealRequest);
};
